module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modal-timelog-edit"
    }
  }, [_c('div', {
    staticClass: "dimmer",
    on: {
      "click": _vm.onDimmerClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup"
  }, [(false) ? _c('inputfield', {
    attrs: {
      "label": "Opgave"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globals.modal_timelog_edit.timelog.project_key),
      expression: "globals.modal_timelog_edit.timelog.project_key"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.globals.modal_timelog_edit.timelog, "project_key", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.projects), function(project, key, i) {
    return _c('option', {
      key: 'tfs23' + i,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(project.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]) : _vm._e(), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Opgave"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.multiselectOptions_project,
      "value": _vm.multielectGetOption(_vm.multiselectOptions_project, 'value', _vm.globals.modal_timelog_edit.timelog.project_key),
      "placeholder": "Vælg...",
      "label": "label",
      "track-by": "value",
      "select-label": "",
      "selected-label": "",
      "deselect-label": "",
      "reset-after": false
    },
    on: {
      "select": function($event) {
        return _vm.multiselectOnSelect_selectProject($event)
      }
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Arbejdstype"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globals.modal_timelog_edit.timelog.worktype),
      expression: "globals.modal_timelog_edit.timelog.worktype"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.globals.modal_timelog_edit.timelog, "worktype", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.globals.worktypes), function(worktype, i) {
    return _c('option', {
      key: 'fesfs' + i,
      domProps: {
        "value": worktype.value
      }
    }, [_vm._v(_vm._s(worktype.title))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]), _c('br'), _vm._v(" "), (false) ? _c('inputfield', {
    attrs: {
      "label": "Kunde",
      "classes": "disabled"
    }
  }, [(_vm.getClient(_vm.timelog.project_key)) ? _c('input', {
    attrs: {
      "type": "text",
      "disabled": "",
      "placeholder": "Timetal"
    },
    domProps: {
      "value": _vm.getClient(_vm.timelog.project_key).name
    }
  }) : _c('input', {
    attrs: {
      "type": "text",
      "disabled": "",
      "placeholder": "Timetal"
    },
    domProps: {
      "value": '?'
    }
  })]) : _vm._e(), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timelog.billable),
      expression: "timelog.billable"
    }],
    attrs: {
      "type": "checkbox",
      "id": "kj12b3kj"
    },
    domProps: {
      "checked": Array.isArray(_vm.timelog.billable) ? _vm._i(_vm.timelog.billable, null) > -1 : (_vm.timelog.billable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.timelog.billable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.timelog, "billable", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.timelog, "billable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.timelog, "billable", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "kj12b3kj"
    }
  }, [_vm._v("Fakturérbar")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Timer"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.globals.modal_timelog_edit.timelog.hours),
      expression: "globals.modal_timelog_edit.timelog.hours",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "step": ".25",
      "min": "0.25",
      "max": "24",
      "placeholder": "Timetal"
    },
    domProps: {
      "value": (_vm.globals.modal_timelog_edit.timelog.hours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.globals.modal_timelog_edit.timelog, "hours", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Dato"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globals.modal_timelog_edit.timelog.date),
      expression: "globals.modal_timelog_edit.timelog.date"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.globals.modal_timelog_edit.timelog.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.globals.modal_timelog_edit.timelog, "date", $event.target.value)
      }
    }
  })]), _c('br')], 1)]), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Kommentar"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globals.modal_timelog_edit.timelog.title),
      expression: "globals.modal_timelog_edit.timelog.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "ect. kommentar"
    },
    domProps: {
      "value": (_vm.globals.modal_timelog_edit.timelog.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.globals.modal_timelog_edit.timelog, "title", $event.target.value)
      }
    }
  })]), _c('br'), _vm._v(" "), _c('btn', {
    attrs: {
      "block": "",
      "color": "2"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Gem")]), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("X")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-891f4edc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/modal-timelog-edit.vue
// module id = 617
// module chunks = 1